<div class="wrapper">

  <div class="block-center mt-4 wd-xl">

    <div class="card card-flat">

      <div class="card-header text-center bg-primary">
        <a href="#">
          <img class="block-center rounded img-logo" src="assets/img/logo_horizontal_bco.png" alt="Clube Conecta" />
        </a>
      </div>

      <!-- VALIDAÇÃO DE CPF -->
      @if (fase == 'check') {
        <div class="card-body">
          <p class="txt-cadastro no-padding">Insira seu CPF<br/>para verificação.</p>
          <div class="input-group with-focus">
            <input class="form-control border-right-0"
              type="text" placeholder="CPF"
              [(ngModel)]="formCheck.cpf" [ngModelOptions]="{standalone: true}"/>
            <div class="input-group-append">
              <span class="input-group-text text-muted bg-transparent border-left-0">
                <em class="fa fa-user"></em>
              </span>
            </div>
          </div>
          @if (errorMessage != '') {
            <div class="text-danger">{{errorMessage}}</div>
          }
          <button class="btn btn-block btn-primary mt-3" (click)="checkCPF()">ENVIAR</button>
          <button class="btn btn-block btn-light mt-3" (click)="goLogin()">VOLTAR</button>
        </div>
      }

      <!-- FORMULARIO DE CADASTRO -->
      @if (fase == 'cadastro') {
        <div class="card-body">
          <p class="txt-cadastro no-padding">Complete suas informações<br/>de cadastro.</p>
          <div class="input-group with-focus">
            <input type="text" placeholder="NOME" class="form-control"
              [(ngModel)]="formCadastro.nome" [ngModelOptions]="{standalone: true}"/>
          </div>
          <div class="input-group with-focus">
            <input type="text" placeholder="SOBRENOME" class="form-control"
              [(ngModel)]="formCadastro.sobrenome" [ngModelOptions]="{standalone: true}"/>
          </div>
          <div class="input-group with-focus">
            <select class="form-control input-sm"
              [(ngModel)]="formCadastro.sexo" [ngModelOptions]="{standalone: true}">
              <option value="">SEXO</option>
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
              <option value="N">Não definido</option>
            </select>
          </div>
          <div class="input-group with-focus">
            <input type="text" class="form-control texto-cinza"
              placeholder="NASCIMENTO"
              [ngModel]="formCadastro.nascimento | date:'dd/MM/yyyy'"
              [ngModelOptions]="{standalone: true}"
              (focus)="showDatePicker = true"/>
            @if (showDatePicker) {
              <div style="position: absolute; z-index:10; min-height:290px;">
                <datepicker class="texto-cinza" [(ngModel)]="formCadastro.nascimento" [ngModelOptions]="{standalone: true}"
                [showWeeks]="false" (selectionDone)="showDatePicker = false"></datepicker>
              </div>
            }
            <span class="input-group-btn">
              <button type="button" (click)="showDatePicker = true" class="btn btn-default">
                <em class="fa icon-calendar"></em>
              </button>
            </span>
          </div>
          <div class="input-group with-focus">
            <input type="tel" placeholder="CELULAR" class="form-control"
              minlength="11" maxlength="11" pattern="[0-9]{11}"
              [(ngModel)]="formCadastro.celular" [ngModelOptions]="{standalone: true}"/>
          </div>
          <div class="input-group with-focus">
            <input type="email" placeholder="EMAIL" class="form-control"
              [(ngModel)]="formCadastro.email" [ngModelOptions]="{standalone: true}"/>
          </div>
          <div class="input-group with-focus">
            <input type="password" placeholder="SENHA" class="form-control"
              minlength="4"
              [(ngModel)]="formCadastro.senha" [ngModelOptions]="{standalone: true}" (keyup)="verificaSenha(formCadastro.senha)"/>
          </div>
          <div class="input-group with-focus">
            <input type="password" placeholder="CONFIRMAR SENHA" class="form-control"
              minlength="4"
              [(ngModel)]="formCadastro.confirmar" [ngModelOptions]="{standalone: true}" (keyup)="confirmaSenha(formCadastro.confirmar)"/>
          </div>
          @if (errorMessage != '') {
            <div class="text-danger">{{errorMessage}}</div>
          }
          <span>A senha da deve conter no mínimo:</span>
          <ul>
            <li [ngClass]="{ 'text-danger' : !tamanhoSenha, 'text-success' : tamanhoSenha }">8 dígitos</li>
            <li [ngClass]="{ 'text-danger' : !caracterMaiusculo, 'text-success' : caracterMaiusculo }">1 letra maiúscula</li>
            <li [ngClass]="{ 'text-danger' : !caracterMinusculo, 'text-success' : caracterMinusculo }">1 letra minúscula</li>
            <li [ngClass]="{ 'text-danger' : !caracterEspecial, 'text-success' : caracterEspecial }">1 caracter especial</li>
            <li [ngClass]="{ 'text-danger' : !caracterNumerio, 'text-success' : caracterNumerio }">1 número</li>
          </ul>
          <button class="btn btn-block btn-primary mt-3" [disabled]="!liberaEnvio" (click)="confirmar()">ENVIAR</button>
        </div>
      }

      <!-- CONFIRMAÇÃO DE DADOS -->
      @if (fase == 'confirma') {
        <div class="card-body">
          <p class="txt-cadastro no-padding">Confira os dados<br/>informados.</p>
          <div class="txt-confirmacao">
            <p><strong>Nome:</strong> {{formCadastro.nomeTratado}}</p>
            <p><strong>CPF:</strong> {{formCadastro.cpf}}</p>
            <p><strong>Sexo:</strong> {{formCadastro.sexo}}</p>
            <p><strong>Nascimento:</strong> {{formCadastro.nascimento | date:'dd/MM/yyyy'}}</p>
            <p><strong>Celular:</strong> {{formCadastro.celular}}</p>
            <p><strong>E-mail:</strong> {{formCadastro.email | lowercase}}</p>
          </div>
          <div class="row">
            <div class="col">
              <button class="btn btn-block btn-light mt-3" (click)="voltarCadastro()">
                VOLTAR
              </button>
            </div>
            <div class="col">
              <button class="btn btn-block btn-primary mt-3" (click)="gravarPrimeiroAcesso()">
                CONFIRMAR
              </button>
            </div>
          </div>
        </div>
      }

      <!-- CONFIRMAÇÃO DE CADASTRO -->
      @if (fase == 'sucesso') {
        <div class="card-body">
          <div class="txt-parabens">
            <p><strong>CADASTRO REALIZADO<br/>COM SUCESSO.</strong></p>
            <p></p>
            <p>Faça seu login e navegue pela plataforma.</p>
          </div>
          <button class="btn btn-block bg-primary mt-3" (click)="goLogin()">
            ACESSAR SISTEMA
          </button>
        </div>
      }

    </div>

  </div>

</div>
